// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/loanreturnconsts.proto (package aurora.core.consts.contractreturn, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/loanreturnconsts.proto.
 */
export const file_consts_loanreturnconsts: GenFile = /*@__PURE__*/
  fileDesc("Ch1jb25zdHMvbG9hbnJldHVybmNvbnN0cy5wcm90bxIhYXVyb3JhLmNvcmUuY29uc3RzLmNvbnRyYWN0cmV0dXJuKtkBChRDb250cmFjdFJldHVyblN0YXR1cxIPCgtVTlNQRUNJRklFRBAAEhIKDlJFVFVSTl9QRU5ESU5HEAESFAoQUkVUVVJOX0NPTVBMRVRFRBACEhMKD1JFVFVSTl9SRUpFQ1RFRBADEhIKDlBFTkRJTkdfQ0FOQ0VMEAQSDAoIQ0FOQ0VMRUQQBRILCgdEUk9QUEVEEAYSIwofUkVUVVJOX1BFTkRJTkdfTEVOREVSU19BUFBST1ZBTBAHEh0KGVJFVFVSTl9SRUpFQ1RFRF9CWV9MRU5ERVIQCCqUAQoaQ29udHJhY3RSZXR1cm5SZWplY3RSZWFzb24SCAoETk9ORRAAEhsKF09VVFNJREVfU1VQUE9SVEVEX0hPVVJTEAESHwobVU5TVVBQT1JURURfTUVTU0FHRV9ERVRBSUxTEAISEwoPVU5LTk9XTl9MT0FOX0lEEAMSDgoKSU5FTElHSUJMRRAEEgkKBU9USEVSEAVCKVonZ2l0bGFiLnBydmJsLmNvbS9hdXJvcmEvY29yZS9zcmMvY29uc3RzYgZwcm90bzM");

/**
 * @generated from enum aurora.core.consts.contractreturn.ContractReturnStatus
 */
export enum ContractReturnStatus {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RETURN_PENDING = 1;
   */
  RETURN_PENDING = 1,

  /**
   * @generated from enum value: RETURN_COMPLETED = 2;
   */
  RETURN_COMPLETED = 2,

  /**
   * @generated from enum value: RETURN_REJECTED = 3;
   */
  RETURN_REJECTED = 3,

  /**
   * @generated from enum value: PENDING_CANCEL = 4;
   */
  PENDING_CANCEL = 4,

  /**
   * @generated from enum value: CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * @generated from enum value: DROPPED = 6;
   */
  DROPPED = 6,

  /**
   * @generated from enum value: RETURN_PENDING_LENDERS_APPROVAL = 7;
   */
  RETURN_PENDING_LENDERS_APPROVAL = 7,

  /**
   * @generated from enum value: RETURN_REJECTED_BY_LENDER = 8;
   */
  RETURN_REJECTED_BY_LENDER = 8,
}

/**
 * Describes the enum aurora.core.consts.contractreturn.ContractReturnStatus.
 */
export const ContractReturnStatusSchema: GenEnum<ContractReturnStatus> = /*@__PURE__*/
  enumDesc(file_consts_loanreturnconsts, 0);

/**
 * possible reasons for returns to be rejected
 *
 * @generated from enum aurora.core.consts.contractreturn.ContractReturnRejectReason
 */
export enum ContractReturnRejectReason {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: OUTSIDE_SUPPORTED_HOURS = 1;
   */
  OUTSIDE_SUPPORTED_HOURS = 1,

  /**
   * @generated from enum value: UNSUPPORTED_MESSAGE_DETAILS = 2;
   */
  UNSUPPORTED_MESSAGE_DETAILS = 2,

  /**
   * @generated from enum value: UNKNOWN_LOAN_ID = 3;
   */
  UNKNOWN_LOAN_ID = 3,

  /**
   * @generated from enum value: INELIGIBLE = 4;
   */
  INELIGIBLE = 4,

  /**
   * @generated from enum value: OTHER = 5;
   */
  OTHER = 5,
}

/**
 * Describes the enum aurora.core.consts.contractreturn.ContractReturnRejectReason.
 */
export const ContractReturnRejectReasonSchema: GenEnum<ContractReturnRejectReason> = /*@__PURE__*/
  enumDesc(file_consts_loanreturnconsts, 1);

